import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import { UserProvider } from '@/contexts/UserContext';
import AppLayout from '@/layouts/AppLayout';
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import PrivateRoute from './PrivateRoute';
import NotFound from "pages/NotFound"; 
import LoginPage from './pages/login'; 
import CareerReport from './pages/career-report';
import Dashboard from './pages/dashboard';
import CareerAssessment from './pages/career-assessment';
import JobMatching from './pages/job-matching';
import Applications from './pages/applications';
import Interviews from './pages/interviews';
import ToxicWorkplaceDatabase from './pages/toxic-workplace-database';
import SalaryInsights from './pages/salary-insights';
import UpskilllingMarketplace from './pages/upskilling-marketplace';
import CareerPivot from './pages/career-pivot';
import MultiStepOnboarding from './pages/multi-step-onboarding';
import MockInterviewDetails from './pages/mock-interview-details';
import RealInterviewDetails from './pages/interview-details';
import JobPostDetails from './pages/job-details';
import Notifications from './pages/notifications';
import Settings from './pages/settings';
import Billing from './pages/billing';
import Support from './pages/support';
import SystemStatus from './pages/system-status';


const ProtectedLayout = () => {
  return (
    <UserProvider>          {/* ← fetches profile only here */}
      <PrivateRoute />
    </UserProvider>
  );
};


const Routes = () => {
return (
<BrowserRouter>
<ErrorBoundary>
<ScrollToTop />
<RouterRoutes>

{/* Public routes */}
<Route path="/login" element={<LoginPage />} />
<Route path="*" element={<NotFound />} />

{/* App layout starts here */}
<Route element={<AppLayout />}>

{/* Protected routes */}
<Route element={<ProtectedLayout />}>
<Route path="/" element={<Dashboard />} />
<Route path="/onboarding" element={<MultiStepOnboarding />} />
<Route path="/career-pivot" element={<CareerPivot />} />
<Route path="/career-assessment/report" element={<CareerReport />} />
<Route path="/career-assessment" element={<CareerAssessment />} />
<Route path="/job-matching" element={<JobMatching />} />
<Route path="/applications" element={<Applications />} />
<Route path="/interviews" element={<Interviews />} />
<Route path="/interview/:id" element={<RealInterviewDetails />} />
<Route path="/mock-interview/:id" element={<MockInterviewDetails />} />
<Route path="/job-details/:id" element={<JobPostDetails />} />
<Route path="/notifications" element={<Notifications />} />
<Route path="/settings" element={<Settings />} />
<Route path="/billing" element={<Billing />} />
<Route path="/support" element={<Support />} />
<Route path="/system-status" element={<SystemStatus />} />

{/*<Route path="/toxic-workplace-database" element={<ToxicWorkplaceDatabase />} />
<Route path="/salary-insights" element={<SalaryInsights />} />
<Route path="/upskilling-marketplace" element={<UpskilllingMarketplace />} />*/}

</Route>
</Route>
</RouterRoutes>
</ErrorBoundary>
</BrowserRouter>
);
};

export default Routes;